import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const BuildingIcon = (props: SvgProps) => <Svg
    {...props}
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'>
    <Path
        d='M3.42871 29.0374V13.9517H8.45728M8.45728 13.9517V29.0374M8.45728 13.9517V3.89453H23.543V13.9517M23.543 29.0374V13.9517M13.4859 29.0374V18.9802H18.5144V29.0374M23.543 13.9517H28.5716V29.0374M13.4859 8.9231V13.9517H18.5144V8.9231H13.4859Z'
        stroke='#3379BD'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round' />
</Svg>;

export default BuildingIcon;
